import "./OrdersDesktopViewComponent.scss";
import template from "./OrdersDesktopViewComponent.html";
import {IComponentOptions} from "angular";
import {Observable} from "rxjs";
import {OrderViewModels} from "../../models/OrderViewModel";
import DefaultEquityOrderListConfiguration from "../defaults/DefaultEquityOrderListConfiguration";
import DefaultOptionOrderListConfiguration from "../defaults/DefaultOptionOrderListConfiguration";
import {OrderViewStore} from "../../store/view/OrderViewStore";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {FeatureNames} from "../../../types/UserConfig";
import {CurrentUser} from "../../../services/user/models/CurrentUser";

export const OrdersDesktopView = "tfOrdersDesktopView";

export function ordersDesktopView(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: OrdersDesktopViewComponentController
    };
}

export class OrdersDesktopViewComponentController {

    public readonly orders$: Observable<OrderViewModels>;
    public readonly optionOrdersView$: Observable<boolean>;
    public readonly equityOrdersView$: Observable<boolean>;

    public readonly defaultEquityOrderListConfig = DefaultEquityOrderListConfiguration;
    public readonly defaultOptionOrderListConfig = DefaultOptionOrderListConfiguration;

    /** @ngInject */
    public constructor(readonly orderViewStore: OrderViewStore,
                       readonly currentUserService: CurrentUserService) {
        this.orders$ = orderViewStore.orders;
        this.optionOrdersView$ = this.buildOptionOrdersView();
        this.equityOrdersView$ = this.buildEquityOrdersView();
    }

    private buildOptionOrdersView(): Observable<boolean> {
        return this.currentUserService.current
                   .map((user) => this.isOptionsUser(user))
                   .publishReplay(1)
                   .refCount();
    }

    private isOptionsUser(user: CurrentUser): boolean {
        return user.hasFeature(FeatureNames.SCREEN_OPTION_ORDERS);
    }

    private buildEquityOrdersView(): Observable<boolean> {
        return this.currentUserService.current
                   .map((user) => this.isEquityUser(user))
                   .publishReplay(1)
                   .refCount();
    }

    private isEquityUser(user: CurrentUser): boolean {
        return user.hasFeature(FeatureNames.SCREEN_EQUITY_ORDERS) &&
            !user.hasFeature(FeatureNames.SCREEN_OPTION_ORDERS);
    }
}
